const module = {
  firestorePath: 'pages',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'page',
  statePropName: 'data',
  namespaced: true, // automatically added

  sync: {
    defaultValues: {
      id: '',
      titleid: '',
      titleEn: '',
      descriptionId: '',
      descriptionEn: '',
      imageUrl: '',
      itemList: []
    }
  },

  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions
  state: {},
  getters: {},
  mutations: {},
  actions: {},
}

export default module
